const AdminMixin = {
    methods: {
        _alreadyLogin() {
            let token = localStorage.getItem('accessToken');
            return token ? true : false;
        },
        _getCurrentAdmin() {
            let admin = localStorage.getItem('rme');
            return admin ? admin : undefined;
        },
        _getCurrentAdminId() {
            let admin = localStorage.getItem('rme');
            return admin ? admin.id : undefined;
        },
        _updateCurrentAdmin(admin) {
            localStorage.setItem('rme', JSON.stringify(admin));
        },
        _isGodAdmin() {
            let adminString = localStorage.getItem('rme');
            let admin = JSON.parse(adminString);
            let adminRole = admin.AdminRole;
            return adminRole.id === 1;
        }
    }
};

export default AdminMixin;
